<div class="header">Start your best quiz!</div>
<div class="buttons">
    <div class="join">Join</div>
    <div (click)="openQuestionGenerator()"
         class="create">
        Start
    </div>
</div>
